import type { WithMetadata } from "../../pages";
import { CompareTheMarketHeader } from "./CompareTheMarketHeader";
import { Header as StandardHeader } from "./Header";
import type { HeaderProps } from "./types";

export * from "./constants";
export * from "./types";

export function Header({ variant, ...props }: WithMetadata<HeaderProps>) {
  if (variant === "comparethemarket") {
    return <CompareTheMarketHeader variant={variant} {...props} />;
  }

  return <StandardHeader variant={variant} {...props} />;
}
